export const IDENTIFIANT_SOUSCRIPTION_FORM_NAME = "identifiantSouscription";
export const CODE_PACKAGE_FORM_NAME = "codePackage";
export const ROLE_OPERATEUR_FORM_NAME = "roleOperateur";
export const TYPE_PAIEMENT_FORM_NAME = "typePaiement";
export const TRANSACTION_AUTORISEE_FORM_NAME = "transactionAutorisee";
export const STATUS_PACKAGE_FORM_NAME = "statusPackage";
export const VALIDITE_PACKAGE_FORM_NAME = "validitePackage";
export const VALIDITE_DU_FORM_NAME = "validiteDu";
export const VALIDITE_AU_FORM_NAME = "validiteAu";
export const STATUS_SOUSCRIPTION_FORM_NAME = "statusSouscription";
export const DEBUT_DATE_SOUSCRIPTION_FORM_NAME = "debutDateSouscription";
export const FIN_DATE_SOUSCRIPTION_FORM_NAME = "finDateSouscription";
export const EXERCICE_SOUSCRIPTION_FORM_NAME = "exercice";
export const PORT_SOUSCRIPTION_FORM_NAME = "port";
